import { Store } from '@reduxjs/toolkit';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AuthenticationManager } from '../Modules/AuthenticationManager/AuthenticationManager';
import { SmoEnvironmentImageClassifier } from '../Modules/ImageClassifier/Smo/SmoEnvironmentImageClassifier';
import { SmoMultiMoonImageClassifier } from '../Modules/ImageClassifier/Smo/SmoMoonTypeImageClassifier';
import { SmoImageComparator } from '../Modules/ImageComparator/SmoImageComparator';
import { SmoImageCropper } from '../Modules/ImageCropper/SmoImageCropper';
import { WebGLImageFilterer } from '../Modules/ImageFilterer/WebGLImageFilterer';
import { SmoMoonListManager } from '../Modules/MoonListManager/SmoMoonListManager';
import { SmoMoonManager } from '../Modules/MoonManager/SmoMoonManager';
import { createStore } from '../Modules/Redux/Global/StoreConfiguration';
import { StoreDependencies } from '../Modules/Redux/Global/StoreDependencies';
import { StoreState } from '../Modules/Redux/Global/StoreState';
import { SmoSocketManager } from '../Modules/Socket/SmoSocketManager';
import { SmoTextProcessingManager } from '../Modules/TextProcessing/SmoTextProcessingManager';
import { TesseractTextReader } from '../Modules/TextReader/TesseractTextReader';
import { TesseractTextReaderLanguageConverter } from '../Modules/TextReaderLanguageConverter/TesseractTextReaderLanguageConverter';
import { SmoUserManager } from '../Modules/UserManager/SmoUserManager';
import { VideoMediaDeviceFinder } from '../Modules/UserMediaManager/VideoMediaDeviceFinder';
import { BACK_URL } from '../Utils/Constants';
import { ReactComponent } from '../Utils/Types';
import { AppNavigation } from './UI/Navigation/AppNavigation';

export function App(): ReactComponent {
  const storeDependencies: StoreDependencies = {
    authenticationManager: new AuthenticationManager(),
    userManager: new SmoUserManager(),
    moonManager: new SmoMoonManager(),
    moonListManager: new SmoMoonListManager(),
    mediaDeviceFinder: new VideoMediaDeviceFinder(),
    imageCropper: new SmoImageCropper(),
    imageFilterer: new WebGLImageFilterer(),
    imageComparator: new SmoImageComparator(),
    textReader: new TesseractTextReader(),
    textReaderLanguageConverter: new TesseractTextReaderLanguageConverter(),
    textProcessingManager: new SmoTextProcessingManager(),
    smoEnvironmentImageClassifier: new SmoEnvironmentImageClassifier(),
    smoMultiMoonImageClassifier: new SmoMultiMoonImageClassifier(),
    socketManager: new SmoSocketManager(BACK_URL)
  };
  const store: Store<StoreState> = createStore(storeDependencies);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <DndProvider backend={HTML5Backend}>
          <AppNavigation />
        </DndProvider>
      </BrowserRouter>
    </Provider>
  );
}
